import React, {Component} from 'react';
import * as firebase from 'firebase/app'
import 'firebase/database'
import 'firebase/auth'
import {notify} from 'react-notify-toast'
import {
  Redirect
} from 'react-router-dom'

class Setup extends Component {
    
  constructor (){
      super()
      this.state = {
          users: [],
          user: null,
          name: '',
          pass: ''
      }

      this.loadUsers                = this.loadUsers.bind(this)
      this.saveUserData             = this.saveUserData.bind(this)
      this.handleUserName           = this.handleUserName.bind(this)
      this.handleNewPass            = this.handleNewPass.bind(this)
      this.changePass               = this.changePass.bind(this)
  }

  render() {

    console.log('this.state.role: ' + this.state.role)

    if(this.state.reset || !firebase.auth().currentUser){
        return (
            <Redirect to={{
            pathname: '/',
            state: { from: this.props.location }
          }}/>
          )
    }

    if(this.state.user!==null){

        let userStar1 = 'star_border'
        let userStar2 = 'star_border'
        let userStar3 = 'star_border'
        let userStar4 = 'star_border'
        let userStar5 = 'star_border'

        if ( this.state.user.stars!==undefined ) {

            if ( this.state.user.stars >= 1 ) {
                userStar1 = 'star'
            }
            if ( this.state.user.stars >= 2 ) {
                userStar2 = 'star'
            }
            if ( this.state.user.stars >= 3 ) {
                userStar3 = 'star'
            }
            if ( this.state.user.stars >= 4 ) {
                userStar4 = 'star'
            }
            if ( this.state.user.stars === 5 ) {
                userStar5 = 'star'
            }

        }

        if(this.state.role!=="" && (this.state.role!=="master" && this.state.role!=="admin")){

            return (
            <div className="module">
                <div className="container moduleHeaderDiv">
                    <b><h2>Configuración</h2></b>
                </div>

                <div className="row">

                    <div className="col-md-4 centered">
                        <b>Perfil de Usuario</b>
                        <br/>
                        {
                            this.state.user!==null && this.state.user.role==="user"?
                                <div>
                                    <i className="material-icons starIcon">{userStar1}</i>
                                    <i className="material-icons starIcon">{userStar2}</i>
                                    <i className="material-icons starIcon">{userStar3}</i>
                                    <i className="material-icons starIcon">{userStar4}</i>
                                    <i className="material-icons starIcon">{userStar5}</i>
                                </div>
                            : null
                        }
                        {
                        this.state.user!==null?
                            <div>
                                Email: {this.state.user.email}
                                <br/>
                                <br/>
                                Nombre y Apellidos:
                                <br/>
                                <input className="form-control setupInput" 
                                    value={this.state.name}
                                    onChange={this.handleUserName}
                                    ref="name" type="text" placeholder="nombre y apellidos ..." />
                                <br/>
                                
                                <button className='btn btn-lignht btn-sm floatRight' onClick={this.saveUserData}>Guardar</button>
                                <br/>

                                { firebase.auth().currentUser.providerData[0].providerId!=='google.com'?
                                    <div>
                                        <br/>
                                        <br/>
                                        Cambiar Contraseña:
                                        <br/>
                                        <small>Mínimo 6 caracteres</small>
                                        <br/>
                                        <input className="form-control setupInput" 
                                            value={this.state.pass}
                                            onChange={this.handleNewPass}
                                            ref="pass" type="password" placeholder="nueva contraseña ..." />
                                        <br/>
                                        <button className='btn btn-lignht btn-sm floatRight' onClick={this.changePass}>Cambiar contraseña</button>
                                    </div>
                                : null }
                                <br/>
                            </div>

                        : null  // TODO: wait anim here 
                        }
                    </div>
                    {
                        this.state.user!==null && (this.state.user.role==="admin" || this.state.user.role==="master")?
                        
                        <div className="col-md-8">
                            <b>Usuarios: ({this.state.users.length})</b>
                            <div className="container usersList">   
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <td>Usuario</td>
                                            <td colSpan="2">Opciones</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                {
                                    this.state.users.map(user => {

                                        let userStateStyle = 'userOn'
                                        if (user.val().state===false){
                                            userStateStyle = 'userOff'
                                        }

                                        let star1 = 'star_border'
                                        let star2 = 'star_border'
                                        let star3 = 'star_border'
                                        let star4 = 'star_border'
                                        let star5 = 'star_border'

                                        if ( user.val().stars!==undefined ) {

                                            if ( user.val().stars >= 1 ) {
                                                star1 = 'star'
                                            }
                                            if ( user.val().stars >= 2 ) {
                                                star2 = 'star'
                                            }
                                            if ( user.val().stars >= 3 ) {
                                                star3 = 'star'
                                            }
                                            if ( user.val().stars >= 4 ) {
                                                star4 = 'star'
                                            }
                                            if ( user.val().stars === 5 ) {
                                                star5 = 'star'
                                            }

                                        }

                                        let name = user.val().email
                                        if ( user.val().name ) {
                                            name = user.val().name
                                        }

                                        return(
                                            <tr key={user.key} className="userRow">
                                                <td>
                                                    <span className={userStateStyle}>{name}</span>
                                                    <br/>
                                                    
                                                    <i className="material-icons starIcon" onClick={()=>this.starUser(user.key,1)}>{star1}</i>
                                                    <i className="material-icons starIcon" onClick={()=>this.starUser(user.key,2)}>{star2}</i>
                                                    <i className="material-icons starIcon" onClick={()=>this.starUser(user.key,3)}>{star3}</i>
                                                    <i className="material-icons starIcon" onClick={()=>this.starUser(user.key,4)}>{star4}</i>
                                                    <i className="material-icons starIcon" onClick={()=>this.starUser(user.key,5)}>{star5}</i>
                                                </td>
                                                <td>
                                                    <i className="material-icons btnIcon" 
                                                        onClick={() => this.toggleState(
                                                                user.key,
                                                                user.val().email,
                                                                user.val().role,
                                                                user.val().state)}
                                                            >delete</i>
                                                    &nbsp;&nbsp;
                                                </td>
                                            </tr>
                                        )
                                    })
                                }
                                    </tbody>
                                </table>
                            </div>
                        
                        </div>
                    : null }
                </div>

                <div className="container">

                </div>
            </div>
            )
        } else {
            return (
                <div className="module">
                  <div className="container waitDiv">
                    <div ref="waitAnimDiv" className="waitAnim"> </div>
                  </div>
                </div>
              )
        }

    }else{

        return (
          <div className="module">
            <div className="container moduleHeaderDiv">
                <h2>Configuración</h2><br/>
                <div className="container waitDiv">
                <div ref="waitAnimDiv" className="waitAnim"> </div>
                </div>
            </div>
          </div>
        )

    }
  }
    
  componentDidMount(){
    this.loadUsers()
  }

  loadUsers(){
    let ref = firebase.database().ref()
    let roleRef = ref.child("users")

    roleRef.on('value', data => {
        let users = []
        let user = null
        data.forEach( childSnapshot => {
            if ( childSnapshot.val().role!=="master" ){
                users.push(childSnapshot)
            }
            if ( childSnapshot.val().email === firebase.auth().currentUser.email ) {
                user = childSnapshot.val()
                user.key = childSnapshot.key
            }
        })
        this.setState({
            users: users,
            user: user,
            name: user.name
        })
    })
  }

  saveUserData () {

    const userName = this.state.name.trim()

    if ( userName==='' ){
        notify.show ('Introduce nombre y apellidos, por favor', 'error', 1250)
        return false
    }

    firebase.database().ref("users").child(this.state.user.key).child("name").set(userName).then ( snap => {
        notify.show ('Datos guardados', 'success', 1250)
    })

  }

  toggleState (userKey, userEmail, userRole, userState) {
    if(userRole!=="master" && this.state.user.email!==userEmail){
        let newState = true
        if(userState==undefined || userState===true){
            newState = false
        }
        firebase.database().ref("users").child(userKey).child("state").set(newState).then ( snap => {
            notify.show ('Datos guardados', 'success', 1250)
        })
    
    }
  }

  starUser ( userKey, value ) {
    firebase.database().ref("users").child(userKey).child("stars").set(value).then ( snap => {
        notify.show ('Puntuación guardada', 'success', 1250)
    })
  }

  handleUserName () {
      this.setState({
        name: this.refs.name.value
      })
  }

  handleNewPass () {
      this.setState({
        pass: this.refs.pass.value
      })
  }

  changePass () {
    if (this.state.pass!=='') {
        // TODO: pass validation
        firebase.auth().currentUser.updatePassword(this.state.pass).then( () => {
            notify.show ('Contraseña modificada', 'success', 1250)
            this.setState({
                pass: ''
            })
        }).catch( error => {
            console.log('ERROR updating password: ', error)

            if ( error.code === 'auth/weak-password' ) {
                notify.show ('La nueva contraseña debe tener al menos 6 caracteres', 'error', 1250)
            } else if ( error.code === 'auth/requires-recent-login' ) {
                notify.show ('El cambio de contraseña requiere una identificación reciente. Cierra sesión y vuelve a identificarte para cambiar la contraseña.', 'error', 1250)
            }
        })
    } else {        
        notify.show ('Introduce contraseña. Debe tener al menos 6 caracteres.', 'error', 1250)
    }
  }

}

export default Setup